import * as enManifestSet from '../../translations.json';

const stringManifest = enManifestSet['default'];
const allTranslations = window.__translations__?.['mi-monitor-web'] || {'en': stringManifest};

type TranslationObject<T> = {
  [P: string]: T;
};

class TranslationServiceController {
  setLanguage(language: string) {
    //If the requested language isn't available create it so it can be populated with english
    if(!allTranslations[language]) {
      allTranslations[language] = {}
    }

    for (let [key, value] of Object.entries(stringManifest)) {
      translations[key] = new Translation(allTranslations[language][key] || value);
    }
  }
}

export const TranslationService = new TranslationServiceController();
export const translations: TranslationObject<Translation> = {};

export class Translation {
  private _value: string;

  constructor(value: string) {
    this._value = value;
  }

  interpolate(interpolationObject: object) {
    let interpolatedValue = this._value;

    if (interpolationObject) {
      for (let placeholder in interpolationObject) {
        const re = new RegExp(placeholder, 'g')
        interpolatedValue = interpolatedValue.replace(re, interpolationObject[placeholder]);
      }
    }
    return interpolatedValue.replace(/}/g, "").replace(/{/g, "");
  }

  get value() {
    return this._value;
  }
}
